import { render } from "./line-chart.vue?vue&type=template&id=3df1b700"
import script from "./line-chart.vue?vue&type=script&lang=js"
export * from "./line-chart.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__